import userApi from "@/api/user";
import Cookies from "js-cookie";
import { create } from "zustand";

export interface Recommender {
  id: number;
  srikrungMemberId: string;
  avatarUrl: string;
  membershipPosition: string;
  phoneNumber: string;
  firstName: string;
  lastName: string;
  email: string;
  otherUrl: string;
  line: string;
  facebook: string;
  youtube: string;
  registerFormUrl: string;
}

const RECOMMENDER_COOKIE_ID = "recommender_id";

const recommenderDefault: Recommender = {
  id: 1,
  srikrungMemberId: "AM00002204",
  avatarUrl: "/image/owner.webp",
  membershipPosition: "1+++ Diamond - รองกรรมการฝ่ายบริหาร",
  phoneNumber: "0962897951",
  firstName: "หจก.บีเอสเค",
  lastName: "สมาร์ท กรุ๊ป",
  email: "Orawaninsure@gmail.com",
  otherUrl: "",
  line: "https://line.me/ti/p/~@agentsrikrung",
  facebook: "https://www.facebook.com/bouyorawanprakunpai#",
  youtube: "https://www.youtube.com/channel/UCqlueqLTKK3cUzqTayNLREg",
  registerFormUrl: "https://www.srikrung-mgm.com/application/u/19",
};
export const useRecommenderState = create<Recommender | null>(() => null);

const recommenderService = {
  setId: (id: number) => Cookies.set(RECOMMENDER_COOKIE_ID, id.toString()),
  getId: () => {
    const id = Cookies.get(RECOMMENDER_COOKIE_ID);
    return id ? parseInt(id) : 1;
  },
  getMemberById: async (id: number): Promise<Recommender> => {
    try {
      if (useRecommenderState.getState()?.id === id) {
        return useRecommenderState.getState()!;
      }

      // update recommender
      recommenderService.setId(id);
      const { data } = await userApi.getById(id);
      useRecommenderState.setState(data.data.user);
      return data.data.user;
    } catch (error) {
      recommenderService.setId(recommenderDefault.id);
      return recommenderDefault;
    }
  },
};

export default recommenderService;
